import React, { useEffect, useState } from 'react'
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import axios from 'axios';
import Select from 'react-select';
import ToastNotification from '../../../components/ToastNotification';
import { useLoading } from '../../../context/LoadingContext';
import { CiEdit } from "react-icons/ci";
import { FaTimes } from 'react-icons/fa';

function CashReceipt({ adminData, companyID, branchID , financialYear }) {

    const { setLoading } = useLoading();
    const [showForm, setShowForm] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [editId, setEditId] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [account, setAccount] = useState([]);
    const [cashAccount, setCashAccount] = useState([]);
    const [branchDetail, setBranchDetail] = useState([])
    const [editingCompanyId, setEditingCompanyId] = useState(null);
    const [showAllocModal, setShowAllocModal] = useState(false);
    const [activeRowIndex, setActiveRowIndex] = useState(null);
    const [costOptions, setCostOptions] = useState([]);
    const [fetchSale, setFetchSale] = useState([]);
    const [amc, setAmc] = useState([]);
    const [fetchRepairInvoice, setFetchRepairInvoice] = useState([]);
    const [accountRow, setAccountRow] = useState([]);
    const [accountOptionsRow, setAccountOptionsRow] = useState([]);

       const [fromMonth, setFromMonth] = useState('');
    const [toMonth, setToMonth] = useState('');  

    
        const [offset, setOffset] = useState(0);
        const limit = 20;
        const [hasMore, setHasMore] = useState(true);
        const [fromDate, setFromDate] = useState();
        const [toDate, setToDate] = useState();
        const [isLocked, setIsLocked] = useState(false);
        const [fy, setFy] = useState([]);
             const [validUpto, setValidUpto] = useState(null);
    
        const [financialRange, setFinancialRange] = useState({
            from_date: '',
            to_date: ''
        });
    

    const getCurrentDateTime = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, "0");
        const day = String(now.getDate()).padStart(2, "0");
        const hours = String(now.getHours()).padStart(2, "0");
        const minutes = String(now.getMinutes()).padStart(2, "0");

        return `${year}-${month}-${day}T${hours}:${minutes}`;
    };


    const [formData, setFormData] = useState({
        account: '',
        amount: '',
        payment_date: getCurrentDateTime(),
        cheque_no: '',
        cheque_date: '',
        remark: '',
        tableRow: [
            { account: '', amount: '', type: '', action: '', allocation: [] }
        ],
        payment_type: '',
    });

    const [files, setFiles] = useState({
        file: null,

    })



    const [toast, setToast] = useState({
        show: false,
        message: '',
        bg: 'success'
    });

    const showToast = (message, bg = 'success') => {
        setToast({ show: true, message, bg });
    };

    const addRow = () => {
        setFormData(prev => ({
            ...prev,
            tableRow: [
                ...(prev.tableRow || []),
                { account: '', amount: '', type: '', action: '' }
            ]
        }));
    };


    const accountOptions = account.map(acc => ({
        value: acc.id,
        label: acc.holder_name,
    }));

    //      const accountOptionsRow = account.map(acc => ({
    //     value: acc.party_id,
    //     label: acc.holder_name,
    // }));

    useEffect(() => {
        const options = accountRow.map(acc => ({
            value: acc.id,
            label: acc.holder_name,
              partyId: acc.party_id
        }));

        setAccountOptionsRow(options);

    }, [accountRow]);

    const handleRowChange = (e, index, field) => {
        const value = e.target.value;
        setFormData(prev => {
            const updatedRows = [...(prev.tableRow || [])];
            updatedRows[index][field] = value;
            return { ...prev, tableRow: updatedRows };
        });
    };

    const removeRow = (index) => {
        setFormData(prev => ({
            ...prev,
            tableRow: (prev.tableRow || []).filter((_, i) => i !== index)
        }));
    };


    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        const fieldName = e.target.name;
        if (file) {
            const fileSizeInMB = file.size / (1024 * 1024);
            if (fileSizeInMB > 2) {
                setToast("File size is too large! Please upload a file smaller than 2MB.", 'danger')
                return;
            }
            setFiles(prevFiles => ({ ...prevFiles, [e.target.name]: file }));
        }
    };

    const handleFormOpen = () => {
        setShowForm(true);
        setEditId(null);
        // setFormData({ status: "" });
    };



    const handleChange = (e) => {
        const name = e.target.name.trim();
        setFormData({
            ...formData,
            [name]: e.target.value
        });
    };


    const totalRowAmount = (formData.tableRow || []).reduce(
        (sum, row) => {
            const amt = Number(row.amount || 0);
            return row.type === "Dr" ? sum - amt : sum + amt;
        },
        0
    );



    const fetchAllData = async () => {
        setLoading(true);
        try {
            const [saleRes, amcRes, repairRes] = await Promise.all([
                axios.get('https://api.skyguard.group/api/fetch-sale-invoice'),
                axios.get('https://api.skyguard.group/api/fetch-amc'),
                axios.get('https://api.skyguard.group/api/fetch-repair-invoice')
            ]);

            // Sale Invoices
            const saleInvoiceOnly = saleRes.data
                .filter(item => item.type_acc === "sale_invoice")
                .filter(item => Number(item.received_amount || 0) < Number(item.grand_total || 0))
                .map(item => ({
                    ...item,
                    source_type: "sale_invoice"
                }));

            // Repair Invoices
            const repairInvoiceOnly = repairRes.data
                .filter(item => item.type_acc === "repair_invoice")
                .filter(item => Number(item.received_amount || 0) < Number(item.grand_total || 0))
                .map(item => ({
                    ...item,
                    source_type: "repair_invoice"
                }));

            // AMC
            const amcData = amcRes.data
                .filter(item => Number(item.received_amount || 0) < Number(item.grand_total || 0))
                .map(item => ({
                    ...item,
                    source_type: "amc"
                }));

            // Set state
            setFetchSale(saleInvoiceOnly);
            setAmc(amcData);
            setFetchRepairInvoice(repairInvoiceOnly);

            return {
                saleInvoiceOnly,
                amcData,
                repairInvoiceOnly
            };

        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };


    const refDocPrefix = {
        sale_invoice: 'SL',
        amc: 'AMC',
        repair_invoice: 'RI'
    };



    // const openAllocModal = async (rowIndex) => {
    //     setLoading(true);
    //     const { saleInvoiceOnly, amcData, repairInvoiceOnly } = await fetchAllData();
    //     setLoading(false);

    //     const selectedPartyId = formData.tableRow[rowIndex].account;
    //     const allPurchases = [
    //         ...saleInvoiceOnly,
    //         ...amcData,
    //         ...repairInvoiceOnly
    //     ];

    //     const partyPurchases = allPurchases.filter(
    //         p => String(p.party) === String(selectedPartyId)
    //     );

    //     if (partyPurchases.length === 0) {
    //         console.warn("No purchases found for this party, modal will not open.");
    //         return;
    //     }

    //     const existingAllocation = formData.tableRow[rowIndex].allocation || [];


    //     const allocationData = partyPurchases.map(p => {
    //         const prevAlloc = existingAllocation.find(a => a.id === p.id);


    //         const prefix = refDocPrefix[p.source_type] || 'UNKNOWN';

    //         return {
    //             id: p.id,
    //             source_type: p.source_type,
    //             party: p.party_name,
    //             ref_doc: `${prefix}/${p.inv_no}/${p.branchId}`, // dynamically set prefix
    //             balance_amount: Number(p.grand_total),
    //             allocated_amount: prevAlloc ? Number(prevAlloc.allocated_amount) : 0
    //         };
    //     });


    //     setFormData(prev => {
    //         const updatedRows = [...prev.tableRow];
    //         updatedRows[rowIndex].allocation = allocationData;
    //         return { ...prev, tableRow: updatedRows };
    //     });

    //     setActiveRowIndex(rowIndex);
    //     setShowAllocModal(true);

    // };


    const openAllocModal = async (rowIndex) => {
        setLoading(true);

        const { saleInvoiceOnly, amcData, repairInvoiceOnly } = await fetchAllData();
        setLoading(false);

        const selectedPartyId =
            formData.tableRow[rowIndex]?.account?.partyId ||
            formData.tableRow[rowIndex]?.account?.value;

        const allPurchases = [
            ...saleInvoiceOnly,
            ...amcData,
            ...repairInvoiceOnly
        ];

        const partyPurchases = allPurchases.filter(
            p => String(p.party) === String(selectedPartyId)
        );

        console.log("SELECTED PARTY ID:", selectedPartyId);
        console.log("MATCHED PURCHASES:", partyPurchases);

        if (partyPurchases.length === 0) {
            console.warn("No purchases found for this party, modal will not open.");
            return;
        }

        const existingAllocation =
            formData.tableRow[rowIndex].allocation || [];

        const allocationData = partyPurchases.map(p => {
            const prevAlloc = existingAllocation.find(a => a.id === p.id);

            const prefix = refDocPrefix[p.source_type] || 'UNKNOWN';

            return {
                id: p.id,
                source_type: p.source_type,
                party: p.party_name,
                ref_doc: `${prefix}/${p.inv_no}/${p.branchId}`,
                balance_amount: Number(p.grand_total),
                allocated_amount: prevAlloc ? Number(prevAlloc.allocated_amount) : 0
            };
        });

        setFormData(prev => {
            const updatedRows = [...prev.tableRow];
            updatedRows[rowIndex].allocation = allocationData;
            return { ...prev, tableRow: updatedRows };
        });

        setActiveRowIndex(rowIndex);
        setShowAllocModal(true); // ✅ NOW IT WILL RUN
    };

    const rowAmount =
        activeRowIndex !== null && Array.isArray(formData.tableRow) && formData.tableRow[activeRowIndex]
            ? Number(formData.tableRow[activeRowIndex].amount || 0)
            : 0;

    const rowAllocations =
        Number.isInteger(activeRowIndex) &&
            formData?.tableRow?.[activeRowIndex]?.allocation
            ? formData.tableRow[activeRowIndex].allocation
            : [];


    const updateAllocation = (id, source_type, value) => {
        setFormData(prev => {
            const updatedRows = [...prev.tableRow];
            const allocations = updatedRows[activeRowIndex].allocation;

            updatedRows[activeRowIndex].allocation = allocations.map(item =>
                item.id === id && item.source_type === source_type
                    ? { ...item, allocated_amount: value }
                    : item
            );

            return { ...prev, tableRow: updatedRows };
        });
    };


    const totalAllocated = rowAllocations.reduce(
        (sum, a) => sum + Number(a.allocated_amount || 0),
        0
    );


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.tableRow.length) {
            showToast("Please add at least one row", "danger");
            return;
        }

        try {

            const formPayload = new FormData();

            formPayload.append('account', formData.account);
            formPayload.append('payment_type', 'cash_receipt');
            formPayload.append('amount', formData.amount);
            formPayload.append('payment_date', formData.payment_date);
            formPayload.append('cheque_no', null);
            formPayload.append('cheque_date', null);
            formPayload.append('remark', formData.remark);
            formPayload.append('rows', JSON.stringify(formData.tableRow));
            formPayload.append("branchName", branchDetail.code);


            if (files.file) {
                formPayload.append('file', files.file);
            }


            if (isEditMode && editingCompanyId) {

                await axios.put(
                    `https://api.skyguard.group/api/update-cash-receipt/${editingCompanyId}`,
                    formPayload,
                    {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    }
                );

                showToast("Cash receipt updated successfully!", "success");
            } else {
                // ADD PAYMENT
                await axios.post(
                    "https://api.skyguard.group/api/cash-receipt",
                    formPayload,
                    {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    }
                );

                showToast("Cash receipt added successfully!", "success");
            }
            cashPaymentDetail( financialRange.from_date,
            financialRange.to_date,
            branchDetail.code,
            0);
            resetForm();
            setShowForm(false);

        } catch (error) {
            console.error("❌ Submit error:", error.response?.data || error.message);
            showToast("Failed to save receipt!", "danger");
        }
    };



    const fecthAccountDetail = async () => {
        try {
            const resParty = await axios.get('https://api.skyguard.group/api/fetch-account');
            const result = resParty.data.result;


            const filter = result.filter(
                acc =>
                    (acc.party_id == 0 || acc.party_id == null) &&
                    acc.type_account?.trim().toUpperCase() === "CASH-IN-HAND"
            );
            setAccount(filter);

            //  const filtered = result.filter(acc => acc.party_id !== 0);

            const filtered = result.filter(acc =>
                (acc.party_id !== 0 || acc.party_id !== null) &&
                acc.type_account?.trim().toUpperCase() !== "BANK ACCOUNT" &&
                acc.type_account?.trim().toUpperCase() !== "CASH-IN-HAND"
            );

            setAccountRow(filtered);
        } catch (error) {
            console.log(error)
        }
    };


    const cashPaymentDetail = async (fromDate,
        toDate,
        branchCode,
        newOffset = 0) => {
      
              if (!branchCode) {
            console.log("Branch code missing");
            return;
        }
    try {

        const params = {
            from_month: fromMonth,
            to_month: toMonth
        };

        const res = await axios.get(
            'https://api.skyguard.group/api/fetch-cash-receipt',
             {
                    params: {
                        from_date: fromDate,
                        to_date: toDate,
                        branch_code: branchCode,
                        limit: limit,
                        offset: newOffset
                    }
                }
        );

        const result = res.data;

        // const sortedData = result.sort((a, b) => b.id - a.id);

        // setCashAccount(sortedData);

         console.log("Fetched:", result.length);

          // FIRST LOAD
            if (newOffset === 0) {

                setCashAccount(result);
                setHasMore(true);

            }
            // LOAD MORE
            else {

                setCashAccount(prev => {
                    const merged = [...prev, ...result];

                    // optional: remove duplicates (safety)
                    const unique = Array.from(
                        new Map(merged.map(item => [item.id, item])).values()
                    );

                    return unique;
                });
            }

            // check if more data exists
            if (result.length < limit) {
                setHasMore(false);
            }

    } catch (error) {
        console.log(error);
    }
};
  const fetchBranchDetail = async () => {
        setLoading(true)
        try {
            const branchRes = await axios.get(`https://api.skyguard.group/api/fetch-branch-localData/${branchID}`);
            setBranchDetail(branchRes.data)
            return branchRes.data.code;
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    };

   const fetchYearDetail = async () => {
          setLoading(true);
          try {
              const branchCode = await fetchBranchDetail();
              const res = await axios.get(
                  `https://api.skyguard.group/api/fetch-financial-year-localData/${financialYear}`
              );
              const yearData = res.data;
              setFy(yearData);
            //   setIsLocked(yearData.is_locked === 1);

                 setValidUpto(yearData.valid_up_to);
                let shouldLock = false;

        // First check is_locked
        if (Number(yearData.is_locked) === 1) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            const validUptoDate = new Date(yearData.valid_up_to);
            validUptoDate.setHours(0, 0, 0, 0);

            // Lock only if valid_up_to date has passed
            shouldLock = validUptoDate <= today;
        }

        setIsLocked(shouldLock);


              setFinancialRange({
                  from_date: yearData.from_date,
                  to_date: yearData.to_date
              });
  
              await cashPaymentDetail(
                  yearData.from_date,
                  yearData.to_date,
                  branchCode,
  
              );
          } catch (error) {
              console.log(error);
          } finally {
              setLoading(false);
          }
      };  


      const isVoucherLocked = (paymentDate) => {
    if (!validUpto || !paymentDate) return false;

    const voucherDate = new Date(paymentDate);
    voucherDate.setHours(0, 0, 0, 0);

    const fyValidUpto = new Date(validUpto);
    fyValidUpto.setHours(0, 0, 0, 0);

    return voucherDate <= fyValidUpto;
};


    const fetchCostCenter = async () => {
        try {
            const res = await axios.get("https://api.skyguard.group/api/fetch-cost-category");
            const data = res.data;

            // Map API data to { value, label } format for react-select
            const formattedOptions = data.map(item => ({
                value: item.id,
                label: `${item.name} (${item.category_name})` // category inside brackets
            }));

            setCostOptions(formattedOptions);

        } catch (error) {
            console.log("Error fetching cost categories:", error);
        }
    };

    const fetchSaleInvoice = async () => {
        setLoading(true)
        try {
            const response = await axios.get('https://api.skyguard.group/api/fetch-sale-invoice');
            const saleInvoiceOnly = response.data.filter(
                item => item.type_acc === "sale_invoice"
            );
            setFetchSale(saleInvoiceOnly);

        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };


    const fetchAmc = async () => {
        setLoading(true)
        try {
            const res = await axios.get('https://api.skyguard.group/api/fetch-amc');
            setAmc(res.data)
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }


    const repairInvoice = async () => {
        setLoading(true)
        try {
            const res = await axios.get('https://api.skyguard.group/api/fetch-repair-invoice');

            const filteredData = res.data.filter(
                item => item.type_acc === 'repair_invoice'
            );

            setFetchRepairInvoice(filteredData);
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        
        fecthAccountDetail();
        fetchBranchDetail();
        fetchYearDetail();
        fetchCostCenter();
        fetchSaleInvoice();
        fetchAmc();
        repairInvoice();
    }, []);

    const handleEdit = (form) => {
 const locked = isVoucherLocked(form.payment_date);
              setIsLocked(locked);
        let parsedItems = [];
        if (form.tableRow) {
            try {
                const firstParse = JSON.parse(form.tableRow);
                parsedItems = JSON.parse(firstParse);
            } catch (err) {
                console.log("Invalid tableRow:", err);
                parsedItems = [];
            }
        }


        if (!Array.isArray(parsedItems) || parsedItems.length === 0) {
            parsedItems = [{ account: '', amount: '', type: '', action: '' }];
        }

        setFormData(prev => ({
            ...prev,
            id: form.id || '',
            // account: form.account || '',
            account: form.account && form.account !== "undefined"
                ? form.account
                : form.account_holder_name || '',
            amount: form.amount || '',
            payment_date: form.payment_date || "",
            cheque_no: form.cheque_no || '',
            cheque_date: form.cheque_date || '',
            remark: form.remark || '',
            tableRow: parsedItems,
            branchName: form.branchName || "",
            inv_no: form.inv_no || ""
        }));


        setFiles({
            file: form.file || null,
        });

        setEditingCompanyId(form.id);
        setIsEditMode(true);
        setShowForm(true);
    };



    const resetForm = () => {
        setFormData({
            account: '',
            amount: '',
            payment_date: getCurrentDateTime(),
            cheque_no: '',
            cheque_date: '',
            remark: '',
            tableRow: [{ account: '', amount: '', type: '', action: '' }]
        });

    }

    const filteredData = cashAccount.filter(itm =>
        Object.values(itm).some(val =>
            String(val).toLowerCase().includes(searchTerm.toLowerCase())
        )
    );

    const allocationsByType = rowAllocations.reduce(
        (acc, item) => {
            acc[item.source_type] = acc[item.source_type] || [];
            acc[item.source_type].push(item);
            return acc;
        },
        { sale_invoice: [], amc: [], repair_invoice: [] }
    );

    const AllocationTable = ({ title, data }) => {
        if (!data.length) return null;

        return (
            <>
                <h6 className="mt-3 text-primary">{title}</h6>
                <table className="table table-bordered">
                    <thead className="table-light">
                        <tr className='table-info'>
                            <th>Ref Doc</th>
                            <th>Balance</th>
                            <th>Allocate</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((item) => (
                            <tr key={item.id + item.source_type}>
                                <td>{item.ref_doc}</td>
                                <td className="text-end">{item.balance_amount}</td>
                                <td>
                                    <input
                                        type="number"
                                        className="form-control"
                                        max={item.balance_amount}
                                        value={item.allocated_amount || ''}
                                        onChange={(e) =>
                                            updateAllocation(item.id, item.source_type, Number(e.target.value))
                                        }
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>


                </table>
            </>
        );
    };


     const handleLoadMore = () => {

        const nextOffset = offset + limit;
        setOffset(nextOffset);

        cashPaymentDetail(
            financialRange.from_date,
            financialRange.to_date,
            branchDetail.code,
            nextOffset
        );
    };

    return (
        <div className='main-section'>
            <ToastNotification
                show={toast.show}
                message={toast.message}
                bg={toast.bg}
                onClose={() => setToast({ ...toast, show: false })}
            />
            <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                <h3 className='my-3 fw-bold fs-5 golos'>Cash Receipt</h3>
                <div className="mb-3 row gx-3 gy-2 align-items-center d-flex justify-content-between">
                    <div className="col-12 col-md-5">
                        <input
                            type="text"
                            className="form-control border-0 border-bottom border-dark"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            required
                        />
                    </div>
                        <div className="col-12 col-md-2 d-flex justify-content-end">
                                               <button
                                                   className={`btn ${showForm ? 'btn-danger' : 'btn-success'}`}
                                                   onClick={() => {
                                                       setShowForm(prev => !prev);
                   
                                                       // when closing form → reset
                                                       if (showForm) {
                                                           setIsEditMode(false);
                                                           setEditingCompanyId(null);
                                                           resetForm();
                                                       }
                                                   }}
                                               >
                                                   {showForm ? (
                                                       <>
                                                           Close <FaTimes size={18} />
                                                       </>
                                                   ) : (
                                                       <>
                                                           Add <AiOutlinePlusCircle size={18} />
                                                       </>
                                                   )}
                                               </button>
                                           </div>
                </div>

                {showForm && (
                    <div className='card p-3 my-3 shadow-sm bg-white border'>
                                <fieldset >
                                     <form onSubmit={handleSubmit}>

                            {isEditMode && (
                                <div className="mb-3">
                                    <label>Document No:</label> <br />
                                    <span className="badge bg-primary px-3 py-2">

                                        {`CR/${formData.inv_no}/${formData.branchName || ""}`}
                                    </span>
                                </div>
                            )}

                            <div className='row g-3'>

                                <div className="col-md-4">
                                    <label className="form-label fw-medium">Account</label>
                                    <div className="d-flex align-items-end mb-3">
                                        <div className="flex-grow-1 me-2">

                                            <Select
                                                options={accountOptions}
                                                value={accountOptions.find(opt => opt.value === Number(formData.account)) || null}
                                                onChange={(selected) =>
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        account: selected ? selected.value : ""
                                                    }))
                                                }
                                                placeholder="Select Account..."
                                                   isDisabled={isEditMode && isLocked}
                                            />
                                        </div>

                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <label className="form-label fw-medium">
                                        Amount
                                    </label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        name="amount"
                                        placeholder="Enter here..."
                                        value={formData.amount}
                                        onChange={handleChange}
                                        required
                                         disabled={isEditMode && isLocked}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label fw-medium">
                                        Date
                                    </label>
                                    <input
                                        type="datetime-local"
                                        className="form-control"
                                        name="payment_date"
                                        placeholder="Enter here..."
                                        value={formData.payment_date}
                                        onChange={handleChange}
                                        required
                                         disabled={isEditMode && isLocked}
                                    />
                                </div>


                                <div className="table-responsive my-4">
                                    <div className="d-flex justify-content-end mb-2">
                                        <button
                                            type="button"
                                            className="btn btn-primary btn-sm col-md-1"
                                            onClick={addRow}
                                             disabled={isEditMode && isLocked}
                                        >
                                            + Add Item
                                        </button>

                                    </div>
                                    <table className="table table-bordered mx-auto text-center align-middle ">
                                        <thead className="table-primary">
                                            <tr>
                                                <th>Account</th>
                                                <th>Amout</th>
                                                <th>Type</th>

                                                <th>Other</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {(formData.tableRow || []).map((row, index) => (
                                                <tr key={index}>
                                                    <td style={{ minWidth: "250px" }} className="d-flex align-items-center">
                                                        <div className="flex-grow-1">

                                                            <Select
                                                                options={accountOptionsRow}
                                                                value={
                                                                    accountOptionsRow.find(
                                                                        opt => opt.value === row.account?.value
                                                                    ) || null
                                                                }

                                                                onChange={(selected) =>
                                                                    handleRowChange(
                                                                        {
                                                                            target: {
                                                                                value: selected
                                                                            }
                                                                        },
                                                                        index,
                                                                        'account'
                                                                    )
                                                                }
                                                                menuPortalTarget={document.body}
                                                                styles={{
                                                                    container: base => ({ ...base, width: "100%" }),
                                                                    menuPortal: base => ({ ...base, zIndex: 9999 })
                                                                }}
                                                                placeholder="Select account..."
                                                                   isDisabled={isEditMode && isLocked}
                                                            />
                                                        </div>
                                                    </td>


                                                    <td className="text-center" >
                                                        <input type='number' className='form-control'
                                                            value={row.amount || ''}
                                                            onChange={(e) => handleRowChange(e, index, 'amount')}
                                                             disabled={isEditMode && isLocked}
                                                        />
                                                    </td>

                                                    <td style={{ minWidth: "100px" }}>
                                                        <Select
                                                            options={[
                                                                { value: "Dr", label: "Dr" },
                                                                { value: "Cr", label: "Cr" }
                                                            ]}
                                                            value={[{ value: "Dr", label: "Dr" }, { value: "Cr", label: "Cr" }].find(
                                                                opt => opt.value === row.type
                                                            ) || null}
                                                            onChange={(selected) => handleRowChange({ target: { value: selected.value } }, index, 'type')}
                                                            menuPortalTarget={document.body}
                                                            styles={{
                                                                container: base => ({ ...base, width: "100%" }),
                                                                menuPortal: base => ({ ...base, zIndex: 9999 })
                                                            }}
                                                               isDisabled={isEditMode && isLocked}
                                                        />
                                                    </td>



                                                    <td>
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary mx-1"
                                                            disabled={
                                                                !(
                                                                    fetchSale.some(p =>
                                                                            String(p.party) === String(row.account?.partyId)
                                                                        ) ||
                                                                    amc.some(p => String(p.party) === String(row.account)) ||
                                                                    fetchRepairInvoice.some(p => String(p.party) === String(row.account))
                                                                )
                                                            }
                                                            onClick={() => openAllocModal(index)}
                                                             disabled={isEditMode && isLocked}
                                                        >
                                                            Alloc
                                                        </button>
                                                    </td>


                                                    <td>
                                                        <button
                                                            type="button"
                                                            className="btn btn-danger btn-sm"
                                                            onClick={() => removeRow(index)}
                                                             disabled={isEditMode && isLocked}
                                                        >
                                                            Delete
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                        <tfoot>
                                            <tr className="fw-bold">
                                                <td colSpan="1" className="text-end">
                                                    Total
                                                </td>
                                                <td className="text-center">
                                                    {totalRowAmount}
                                                </td>
                                                <td colSpan="4"></td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>



                                <div className='row g-2'>

                                    <div className="col-md-6">
                                        <label className="form-label fw-medium">Upload Attachments</label>

                                        <input type="file" className="form-control" name='file' accept="image/*,application/pdf" onChange={handleFileChange}  disabled={isEditMode && isLocked} />
                                        {isEditMode && files.file && typeof files.file === "string" && (
                                            <div className="mt-2">
                                                <span>Previous file: </span>
                                                <a href={`https://api.skyguard.group/uploads/${files.file}`} target="_blank" rel="noopener noreferrer">{files.file}</a>
                                            </div>
                                        )}
                                    </div>
                                    <div className='col-md-6'>
                                        <label htmlFor='remark' className="form-label fw-medium">Remarks</label>
                                        <textarea
                                            className="form-control"
                                            name="remark"
                                            id="remarks"
                                            placeholder="Enter here..."
                                            rows="6"
                                            value={formData.remark}
                                            onChange={handleChange}
                                            required
                                             disabled={isEditMode && isLocked}
                                        />
                                    </div>
                                </div>
                            </div>


                            <div className='d-flex justify-content-end mt-4 gap-2'>
                                <button type="submit" className='btn btn-success'  disabled={isEditMode && isLocked}>
                                    {isEditMode ? 'Update' : 'Save'}
                                </button>
                                <button
                                    type='button'
                                    className='btn btn-danger'
                                    onClick={() => {
                                        setShowForm(false); setIsEditMode(false); resetForm();
                                    }}
                                >
                                    Cancel
                                </button>
                            </div>
                        </form>
                                </fieldset>
                      
                    </div>
                )}
 

   

                <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
                    <table className='table table-bordered table-striped table-hover text-center align-middle'>

                        <thead className='table-info'>
                            <tr>
                                <th scope='col'> SN</th>
                                <th scope='col'>Action</th>
                                <th scope='col'>Doc No</th>
                                <th scope='col'>Account</th>
                                <th scope='col'>Payment Date</th>
                                <th scope='col'>Amount</th>
                                <th scope='col'>Remark</th>

                            </tr>
                        </thead>
                        <tbody>


                            {filteredData.map((acc, idx) => (
                                <tr key={idx}>
                                    <td>{filteredData.length - idx} </td>
                                    <td>
                                        <button className="btn btn-success" onClick={() => handleEdit(acc)}>
                                            <CiEdit size={20} />
                                        </button>
                                    </td>
                                    <td> {`CR/${acc.inv_no}/${acc.branchName}/${fy.financial_year.split('-')[0]}`}</td>
                                    <td>{acc.account_holder_name} </td>
                                    <td>{acc.payment_date}</td>
                                    <td>{acc.amount}</td>
                                    <td>{acc.remark} </td>
                                </tr>
                            ))}

                        </tbody>
                    </table>
                     {hasMore && (
                            <div className="text-center mt-3">
                                <button
                                    className="btn btn-primary"
                                    onClick={handleLoadMore}
                                >
                                    Load More
                                </button>
                            </div>
                        )}
                </div>
                {showAllocModal && (

                    <div className="modal fade show d-block" tabIndex="-1">
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Allocation</h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => setShowAllocModal(false)}
                                    />
                                </div>
                                <div className="modal-body">
                                    <div className="row mb-3">
                                        <div className="col-md-4">
                                            <label className="form-label fw-medium">Amount</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={rowAmount}
                                                readOnly
                                            />
                                        </div>
                                    </div>



                                    <AllocationTable
                                        title="Sale Invoices"
                                        data={allocationsByType.sale_invoice}
                                    />
                                    <AllocationTable
                                        title="AMC Invoices"
                                        data={allocationsByType.amc}
                                    />
                                    <AllocationTable
                                        title="Repair Invoices"
                                        data={allocationsByType.repair_invoice}
                                    />

                                    {totalAllocated !== rowAmount && (
                                        <div className="text-danger fw-medium">
                                            Allocated amount must match total amount
                                        </div>
                                    )}



                                    <div className="col-md-4">
                                        <label className="form-label fw-medium">Total Amount</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            value={totalAllocated}
                                            readOnly
                                        />
                                    </div>



                                </div>


                                <div className="modal-footer">
                                    <button
                                        className="btn btn-secondary"
                                        onClick={() => setShowAllocModal(false)}
                                    >
                                        Cancel
                                    </button>

                                    <button
                                        className="btn btn-primary"
                                        disabled={totalAllocated !== rowAmount}
                                        onClick={() => setShowAllocModal(false)}
                                    >
                                        Save Allocation
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default CashReceipt